import { getCubaTimeParts } from './cubaTime';
import {
  EASTERN_TIMEZONE,
  formatHHMM,
  getZonedTimeParts,
  parseHHMM,
  zonedWallTimeToUtc,
} from './zonedWallTime';

/**
 * Map an Eastern (America/New_York) HH:MM on the Eastern calendar day of `nowUtc`
 * to Cuba civil HH:MM (fixed UTC−5).
 */
export function easternHHMMToCubaHHMM(
  easternHHMM: string,
  nowUtc: Date = new Date(),
): string {
  const easternDay = getZonedTimeParts(EASTERN_TIMEZONE, nowUtc);
  const { hour, minute } = parseHHMM(easternHHMM);
  const instant = zonedWallTimeToUtc(
    EASTERN_TIMEZONE,
    easternDay.year,
    easternDay.month,
    easternDay.day,
    hour,
    minute,
  );
  const cuba = getCubaTimeParts(instant);
  return formatHHMM(cuba.hours, cuba.minutes);
}
